export const LOGS = 'Logs';
export const TABLE = 'Table';
export const PROCEDURE = 'Procedure';
export const ICF = 'ICF';
